<template>
  <div>
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-container>
        <v-row>
          <v-col xs="12" md="12">
            <v-card outlined>
              <v-card-subtitle class="pb-0">
                <h2>Mi cuenta</h2>
              </v-card-subtitle>
              <v-card-text class="text--primary">
                <v-divider></v-divider>

                <v-row>
                  
                  <v-col cols="12" xs="12" md="6">
                    <v-text-field
                        v-model="myAccount.nombres"
                        id="account__nombres__text"
                        :counter="80"
                        :error-messages="
                        getErrors('myAccount.nombres', 'El nombre')
                      "
                        label="Nombre (s)"
                        required
                        @input="$v.myAccount.nombres.$touch()"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" xs="12" md="6">
                    <v-text-field
                        v-model="myAccount.paterno"
                        id="account__apellido_paterno__text"
                        :counter="50"
                        :error-messages="
                        getErrors('myAccount.paterno', 'El apellido paterno')
                      "
                        label="Apellido paterno"
                        required
                        @input="$v.myAccount.paterno.$touch()"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" xs="12" md="6">
                    <v-text-field
                        v-model="myAccount.materno"
                        id="account__apellido_materno__text"
                        :counter="50"
                        :error-messages="
                        getErrors('myAccount.materno', 'El apellido materno')
                      "
                        label="Apellido materno"
                        @input="$v.myAccount.materno.$touch()"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" xs="12" md="6">
                    <v-text-field
                        readonly
                        v-model="planes[myAccount.tipoSuscripcion]"
                        id="account__tipo_suscripcion__text"
                        label="Tipo de suscripción"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" xs="12" md="6">
                    <v-btn
                        block
                        id="account__actualizar_mis_datos__button"
                        color="secondary"
                        @click.prevent="onUpdate"
                        :loading="loading"
                    >Actualizar mis datos</v-btn
                    >
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import { mdiEyeOffOutline, mdiEyeOutline } from '@mdi/js'
import { pushNotification, userActions, userData } from '@/store/helpers'
import { required, maxLength, sameAs } from 'vuelidate/lib/validators'
import VuelidateHelper from '@/utils/VuelidateHelper'
import { strongPassword } from '@/utils/VuelidateCustoms'

export default {
  name: 'Account',
  data: () => ({
    icon: {
      eye: mdiEyeOutline,
      eyeOff: mdiEyeOffOutline
    },
    valid: true,
    loading: false,
    showPassword: false,
    planes: ['Sin Plan','Plan Gratuito','Plan Plus'],
    lazy: false,
    vuelidateHelper: null,
    myAccount: {
      nombres: '',
      paterno: '',
      materno: ''
    }
  }),
  created() {
    this.vuelidateHelper = new VuelidateHelper(this.$v)
    this.myAccount = Object.assign({}, this.accountData)
  },
  validations: {
    myAccount: {
      nombres: {
        required,
        maxLength: maxLength(80)
      },
      paterno: {
        required,
        maxLength: maxLength(50)
      },
      materno: {
        maxLength: maxLength(50)
      }
    }
  },
  computed: {
    ...userData
  },
  methods: {
    ...userActions,
    onUpdate() {
      this.$v.$touch()
      if (!this.$v.$anyError) {
        this.loading = true

        this.updateAccount({
          nombres: this.myAccount.nombres,
          paterno: this.myAccount.paterno,
          materno: this.myAccount.materno
        })
            .then(data => {
              if (data.success) {
                const successful = data.successful
                pushNotification(
                    this.$store,
                    `${successful.message}`,
                    'success',
                    'left'
                )
              } else {
                const error = data.data.error
                pushNotification(this.$store, `${error.message}`, 'error', 'left')
              }

              this.loading = false
            })
            .catch(error => {
              let message = error
              if (error.response) {
                message = error.response.data.msg
                    ? error.response.data.msg
                    : error.response.data.error.message
              }

              pushNotification(this.$store, `${message}`, 'error', 'left')
              this.loading = false
            })
      }
    },
    getErrors(campo, label = '') {
      return this.vuelidateHelper.getErrors(campo, label)
    }
  }
}
</script>
